<template>
  <img loading="lazy" class="log-show" :src="logo" />
</template>
<script>
  import logo from '@/assets/imgs/baseIcon/logo.png';
  import logoW from '@/assets/imgs/baseIcon/logo-w.png';
  export default {
    name: 'logo',
    components: {},
    props: {
      selected: {
        default: true,
        type: Boolean
      }
    },
    data() {
      return {
        logo,
        logoW
      };
    },
    methods: {},
    created() {}
  };
</script>
<style lang="less" scoped>
  .log-show {
    width: 100px;
  }
</style>
